// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3aC0e","title":"InfoRow_title__2KWhO"};